import { toast } from 'react-toastify'
import { removeMask } from './removeMask'
interface IHashCardIugu {
  accountId: string
  number: string
  verification_value: string
  expiration: string
  fullName: string
}

interface IHashCardIuguErrors {
  accountId: string
  number: string
  verification_value: string
  expiration: string
  first_name: string
  last_name: string
}

export const hashCardIugu = async ({
  accountId,
  number,
  verification_value,
  expiration,
  fullName,
}: IHashCardIugu): Promise<string> => {
  try {
    if (typeof window !== 'undefined') {
      Iugu.setAccountID(accountId)
      process.env.NEXT_PUBLIC_API_ENV !== 'production' && Iugu.setTestMode(true)

      const month = expiration.split('/')[0] || ''
      const year = '20' + expiration.split('/')[1] || ''
      const first_name = fullName?.split?.(' ')?.[0] || ''
      const last_name = fullName?.split?.(' ')?.[1] || ''

      return new Promise((resolve, reject) => {
        Iugu.createPaymentToken(
          {
            number: removeMask(number),
            verification_value,
            month: month,
            year: year,
            first_name,
            last_name,
          },
          function (response: { errors: Promise<IHashCardIuguErrors>; id: string | Promise<string> }) {
            if (response.errors) {
              console.log(response.errors)
              toast.error('Erro ao processar pedido, verifique os dados do seu cartão e tente novamente.')
              reject(new Error('Erro ao processar seu pagamento'))
            } else {
              resolve(response.id)
            }
          },
        )
      })
    }

    return ''
  } catch (error) {
    return 'Ocorreu um erro inesperado'
  }
}
